export const LOG_TYPE_FAILED_EXCEPTION = 1
export const LOG_TYPE_FAILED_NO_VALID_PHONE_NUMBER = 2
export const LOG_TYPE_SKIPPED_ROW_EMPTY = 3
export const LOG_TYPE_SKIPPED_FROM_SETTINGS = 4
